import { render, staticRenderFns } from "./foldModel.vue?vue&type=template&id=0df6454b&scoped=true&"
import script from "./foldModel.vue?vue&type=script&lang=js&"
export * from "./foldModel.vue?vue&type=script&lang=js&"
import style0 from "./foldModel.vue?vue&type=style&index=0&id=0df6454b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df6454b",
  null
  
)

export default component.exports